<template>
  <div
    v-if="!isElectronEnv"
    class="w-full h-full flex flex-col items-center cursor-pointer group text-black-white text-center transition-colors duration-300"
    @click="handleScan"
  >
    <div class="group-hover:border-solid transition-all duration-300">
      <Icon
        icon="Function-Wireframe-Add1"
        class="size-12"
        :class="{ 'animate-spin': isScanning }"
      />
    </div>
    <div class="text-m-medium">
      {{ t('common.add') }}<br />{{ t('home.deviceCard.productDevice') }}
    </div>
    <!-- <div class="h-5.5 mt-1"></div> -->
    <!-- 占位符以对齐电池高度 -->
  </div>
</template>

<script lang="ts" setup>
  import { Icon } from '@rapoo/element'
  import { useDeviceStore } from '@/stores/device'
  import { storeToRefs } from 'pinia'
  import { isElectron } from '@/utils/env'
  import { useLocaleStore } from '@/stores/locale'

  const deviceStore = useDeviceStore()
  const { isScanning } = storeToRefs(deviceStore)
  const isElectronEnv = isElectron()
  const { t } = useLocaleStore()

  const handleScan = () => {
    deviceStore.scan()
  }
</script>
